import cloudFunctionApi from '../../../cloudfunctions';
import firebaseApi from '../../../firebase/firebaseApi';
import {
	useUserAuthContext,
	useUserDetailsContext,
} from '../../../providers/UserProvider';
import { LoadingDots } from '../../Management/subcomponents/LoadingDots';
import { SafetyCourses } from './SafetyCourses';

export const SafetyCoursesWrapper = (): JSX.Element => {
	const userDetails = useUserDetailsContext();
	const user = useUserAuthContext();

	return !userDetails || !user ? (
		<LoadingDots />
	) : (
		<SafetyCourses
			userDetails={userDetails}
			firebaseApi={firebaseApi}
			user={user}
			cloudFunctionApi={cloudFunctionApi}
		/>
	);
};
